import React, { useEffect, useRef, useState } from "react";



import "./BybSurveyDeck.css"

// import surveyone from "../../assets/images/surveyone.svg"
// import surveytwo from "../../assets/images/surveytwo.svg"
// import surveythree from "../../assets/images/surveythree.svg"
// import surveyfour from "../../assets/images/surveyfour.svg"

function BybSurveyDeck() {

  const [isVisible, setIsVisible] = useState(false);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);
  return (
   <>
   <section className='bybsurveydeck'>
<div className='container'>
<div className='bybsurveydeck-header'>
<p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}
              >IN KIT – THE SURVEY DECKS</p>
<h1> <span className="d-inline d-md-block">Perspectives Can Shape</span> Your Brand’s Impact.</h1>
<p>Create surveys with must-ask questions that unlock invaluable insights from the people who shape your brand's success. Plus, transform breaks into moments of fun and connection with team games using the cards! </p>
</div>

<div className='bybsurveydeck-cardmain'>
<div className='bybsurveydeck-cardone'>
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/csd.svg" alt="Customer Survey Deck cover" />
<p><span style={{ color: "black" }}> Customer Survey Deck –</span> Your Customers Hold the Key to Your Brand’s Evolution.</p>
</div>
<div className='bybsurveydeck-cardtwo'>
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/esd.svg" alt="Employee Survey Deck cover" />
<p><span style={{ color: "black" }}> Employee Survey Deck –</span>  Empower Your Team to Elevate Your Brand’s Purpose.</p>
</div>
<div className='bybsurveydeck-cardthree'>
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/psd.svg" alt="Partner Survey Deck cover" />
<p><span style={{ color: "black" }}> Partner Survey Deck –</span>  Collaborate and Innovate with Insights that Fuel Progress.</p>
</div>
<div className='bybsurveydeck-cardfour'>
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/isd.svg" alt="Investor Survey Deck cover" />
<p><span style={{ color: "black" }}> Investor Survey Deck –</span>  Align Ideas With Visions Through a Brand That People Invest in.</p>
</div>
</div>


</div>






   </section>
   </>
  )
}

export default BybSurveyDeck
